// src/components/CustomButton.tsx
import React from 'react';
import {
  Button,
  CircularProgress,
  ButtonProps,
  Typography,
} from '@mui/material';

interface CustomButtonProps extends ButtonProps {
  loading?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  loading = false,
  disabled,
  ...props
}) => {
  return (
    <Button
      {...props}
      sx={{
        ...props.sx,
        bgcolor: props.color ? `${props.color}.main` : 'primary.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textTransform: 'none',
      }}
      fullWidth
      disabled={loading || disabled}
      startIcon={
        loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          props.startIcon
        )
      }
    >
      <Typography variant="body2">
        {loading ? 'Loading...' : children}
      </Typography>
    </Button>
  );
};

export default CustomButton;
